import React, { useState } from "react";
import { intl } from "LocaleWrapper";
import { useMutation } from "@apollo/client";

import { Button, FormGroup, showSnackbar, Tag, TagSize } from "@cofano/cck";
import { Box, Popover } from "@mui/material";

import usePopover from "components/hooks/usePopover";

import RechargeBillingStateSelect from "../selects/RechargeBillingStateSelect";

import { UpdateRechargeBillingStatesDocument } from "__generated__/view/recharge/graphql/recharge.mutations.generated";
import { RechargeBillingState } from "__generated__/enums";

const RechargeBillingStateStatus = ({
	id,
	value,
	refetch,
}: {
	id: number;
	value: RechargeBillingState | null;
	refetch: () => void;
}) =>  {
	const [ selectedValue, setSelectedValue ] = useState<RechargeBillingState | null>(value);
	const isButtonDisabled = selectedValue == value;

	const { popoverProps, onPopoverOpen, onPopoverClose } = usePopover({
		trigger: "click",
	});

	const [ updateBillingStates, { loading } ] = useMutation(UpdateRechargeBillingStatesDocument);

	const getTag = () => {
		switch (value) {
			case RechargeBillingState.Billed:
				return <Tag text={intl.formatMessage({ id: "RECHARGE_BILLING_STATE_BILLED" })} color="#7fe77f" size={TagSize.SMALL} />;
			default:
				return <Tag text={intl.formatMessage({ id: "RECHARGE_BILLING_STATE_OPEN" })} color="#dbdbdb" size={TagSize.SMALL} />;
		}
	};

	return (
		<React.Fragment>
			<Popover {...popoverProps}>
				<Box p={2}>
					<FormGroup label={intl.formatMessage({ id: "RECHARGE_BILLING_STATE" })} overflow="hidden">
						<RechargeBillingStateSelect
							value={selectedValue}
							onChange={(v) => setSelectedValue(v ?? RechargeBillingState.Open)} />
					</FormGroup>

					<div>
						<Button
							onClick={() => {
								updateBillingStates({
									variables: {
										ids: [ id ],
										billingState: selectedValue!,
									},
								}).then(() => {
									onPopoverClose();
									showSnackbar(intl.formatMessage({ id: "SUCCESSFUL_SAVED" }), { variant: "success" });
									refetch();
								});
							}}
							disabled={isButtonDisabled || loading}
							loading={loading}
							size="small">
							{intl.formatMessage({ id: "SAVE" })}
						</Button>
					</div>
				</Box>
			</Popover>

			<div style={{ cursor: "pointer" }} onClick={onPopoverOpen}>
				{getTag()}
			</div>
		</React.Fragment>
	);
};

export default RechargeBillingStateStatus;
